import { useEffect, useState } from "react";

import { fetchMacroCodes } from "shared/actions/sysActions";
import { GateProps } from "shared/components/GateProps";
import { useHasLoaded } from "shared/hooks/requestStatusHooks";

import { useAppDispatch, useAppSelector } from "store/hooks";

const MacroCodeGate = ({ children, LoadingEl, ErrorEl }: GateProps) => {
  const dispatch = useAppDispatch();
  const macroCodesEnabled = useAppSelector(
    ({ auth }) => auth.user?.userprofile?.enable_macro_helpers
  );

  if (macroCodesEnabled === undefined)
    throw new Error("User must be loaded before MacroCodeGate is rendered");

  const loadedMacroCodes = useHasLoaded(fetchMacroCodes);

  const [hasError, setHasError] = useState(false);
  useEffect(() => {
    if (macroCodesEnabled && !loadedMacroCodes) {
      dispatch(fetchMacroCodes()).catch(() => {
        setHasError(true);
      });
    }
  }, [macroCodesEnabled, loadedMacroCodes]);

  if (hasError)
    return (
      <ErrorEl className="MacroCodeGate">Failed to load Macro Codes</ErrorEl>
    );

  if (macroCodesEnabled === true && !loadedMacroCodes)
    return (
      <LoadingEl className="MacroCodeGate">Loading Macro Codes...</LoadingEl>
    );

  return <>{children}</>;
};

export default MacroCodeGate;
